import type { HotelSearchResult } from './types'

export const EMPTY_HOTEL_SEARCH_FILTERS: App.OfferListFilters = {}
export const EMPTY_HOTEL_SEARCH_FILTER_OPTIONS: NonNullable<HotelSearchResult['filterOptions']> = {
  inclusions: [],
  amenities: [],
}
export function hasHotelSearchFilters(filters: App.OfferListFilters): boolean {
  return !!(filters.customerRatingGte || filters.inclusions?.length || filters.amenities?.length)
}

export function normalizeHotelSearchFilters(filters: App.OfferListFilters): App.OfferListFilters {
  return {
    customerRatingGte: filters.customerRatingGte || undefined,
    inclusions: filters.inclusions?.length ? Array.from(new Set(filters.inclusions)).sort() : undefined,
    amenities: filters.amenities?.length ? Array.from(new Set(filters.amenities)).sort() : undefined,
  }
}

export function getHotelSearchFiltersKey(filters: App.OfferListFilters): string {
  return JSON.stringify(normalizeHotelSearchFilters(filters))
}
